// Module
var code = "<div id=\"page-title\" class=\"d-flex\"> <div class=\"tabs-container mobile-tabs-container\" style=\"height:100%!important\"> <button class=\"tab-active\" id=\"title-addon\"></button> </div> </div> <div class=\"h-100 scroll-y p-3\" id=\"mobile-quotes-container\"> </div>";
// Exports
export default code;